// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"895":"ad82da29","2123":"b3e55c82","2894":"b8b29f4d","5742":"cbede663","5906":"f3b164bb","6334":"a6d8bf13","6813":"1a2a7b07","7155":"f3b164bb","8514":"4d4df255","8914":"71db3d51"}[chunkId] + ".chunk.css";
};